import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import muthumari from '../../../../assets/images/Doctorsimages/dr.muthumari.png'
import favicon from "./../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const MuthumariDoc = () => {
  const navigate = useNavigate();
   useEffect(() => {
       document.title = "Dr. M. Muthumari | Best Homeopathy & Facial Aesthetics Doctor in Valasaravakkam, Chennai";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. M. Muthumari (BHMS, FFAC), female homeopathy and facial aesthetics doctor at H-Cura Valasaravakkam, Chennai. Expert in homeopathy, skin, hair, yoga, child psychology, and holistic care for chronic diseases, acne, pigmentation, and lifestyle disorders."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "best homeopathy doctor in Valasaravakkam Chennai, female homeopathy doctor in Chennai, homeopathy doctor near Porur and Alwarthirunagar, holistic doctor in Valasaravakkam, cosmetic doctor in Valasaravakkam Chennai, facial aesthetics doctor in Chennai, yoga and homeopathy doctor in Chennai, child psychology doctor in Chennai, homeopathy doctor for acne and pigmentation in Ramapuram, natural hair fall treatment near Alwarthirunagar, homeopathy clinic in Valasaravakkam Chennai, female doctor for PCOS in Chennai"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-muthumari-homeopathy-facial-aesthetics-valasaravakkam-chennai");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-muthumari-homeopathy-facial-aesthetics-valasaravakkam-chennai");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

     const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');
  container.classList.add('veenadoc-pdf-mode');
  const originalStyles = new Map();
  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });
  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }
  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });
  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const marginLeft = 10;
      const marginRight = 10;
      const availableWidth = pdfWidth - marginLeft - marginRight;
      const scaleFactor = availableWidth / canvasWidth;
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.Muthumari_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');
      container.classList.remove('veenadoc-pdf-mode');
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. M. Muthumari</span>
                  <span className="veenadoc-title-credentials">(BHMS, FFAC)</span>
                  <span className="veenadoc-title-location">Valasaravakkam, Chennai</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Experienced Consultant in Homeopathy, Facial Aesthetics, and Clinical Cosmetology at H-Cura Valasaravakkam, Chennai. 
                    With expertise in classical homeopathy, modern facial aesthetics, yoga therapy, and child psychology, she provides 
                    integrated and natural healthcare solutions for patients seeking holistic healing.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
              className="veenadoc-btn-primary-gradient"
              onClick={() => navigate('/bookconsultation')}
            >
              <span className="veenadoc-btn-icon">📞</span>
              <span>Book Consultation</span>
              <div className="veenadoc-btn-shine"></div>
            </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={muthumari} alt="Dr. M. Muthumari – Homeopathy & Facial Aesthetics Doctor in Valasaravakkam, Chennai" className="veenadoc-doctor-image" title='Dr. M. Muthumari | Best Female Homeopathy Doctor in Valasaravakkam Chennai' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. M. Muthumari</h2>
                  <p>
                    Dr. M. Muthumari (BHMS, FFAC, Diploma in Yoga, Diploma in Child Psychology) is an experienced and compassionate 
                    Consultant in Homeopathy, Facial Aesthetics, and Clinical Cosmetology, currently practicing at H-Cura Homeopathy 
                    Clinic, Valasaravakkam, Chennai. With her strong academic background and holistic vision of medicine, she has 
                    quickly established herself as a trusted name among patients looking for the best homeopathy doctor in Valasaravakkam Chennai.
                  </p>
                  <p>
                    Her expertise combines classical homeopathy with modern facial aesthetics, cosmetology, yoga therapy, and child 
                    psychology, giving patients an integrated and natural approach to healthcare.
                  </p>
                </div>

                {/* Educational Background */}
                <div className="veenadoc-article-block">
                  <h2>Educational Excellence & Professional Journey</h2>
                  <p>
                    She completed her Bachelor of Homeopathic Medicine and Surgery (BHMS) from Sarada Krishna Homoeopathic Medical 
                    College and later specialized in aesthetics by earning a Fellowship in Facial Aesthetics and Clinical Cosmetology 
                    (FFAC) from the prestigious IICAD Academy. In addition, she holds a Diploma in Yoga and a Diploma in Child Psychology, 
                    qualifications that allow her to offer a wide range of treatments.
                  </p>
                  <p>
                    She began her medical journey at Meenakshi Mission Hospital in Madurai, where she gained valuable hands-on experience, 
                    before moving on to private practice. Today, she is one of the most promising female homeopathy doctors in Chennai, 
                    known for her gentle care and holistic treatment methods.
                  </p>
                </div>

               
                     <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS, FFAC, Yoga, Child Psychology</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homeopathy & Facial Aesthetics</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">H-Cura Valasaravakkam, Chennai</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Areas Served:</span>
                      <span className="veenadoc-info-value">Porur, Alwarthirunagar, Ramapuram</span>
                    </div>
                  </div>
                </div>
                
                 <div className="veenadoc-article-block">
                  <h2>Specialized Trichology & Hair Care Solutions</h2>
                  <p>
                    Dr. Muthumari has gained recognition as a trichology doctor in Chennai specializing in hair fall,  dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP (Platelet-Rich Plasma), GFC (Growth Factor Concentrate), Mesotherapy, Stem Cell Therapy, Laser Hair Therapy and exosome  to ensure effective and long-lasting results.
                  </p>
                  <p>
                    Her expertise ensures that patients not only regain healthy hair but also confidence and peace of mind.
                  </p>
                </div>


                {/* Chronic Disease Management */}
                <div className="veenadoc-article-block">
                  <h2>Expertise in Chronic Disease Management</h2>
                  <p>
                    At H-Cura Valasaravakkam, Dr. Muthumari provides treatments for a variety of chronic illnesses including asthma, 
                    arthritis, thyroid disorders, migraines, diabetes complications, digestive issues, and hormonal imbalances. 
                    Patients looking for a homeopathy doctor near Porur, Alwarthirunagar, and Ramapuram often consult her for 
                    long-term health management.
                  </p>
                  <p>
                    Her approach focuses on addressing the root causes of disease through natural remedies that are safe, non-invasive, 
                    and free from side effects. She designs personalized homeopathy plans that address lifestyle, diet, stress, and 
                    immunity, ensuring sustainable recovery.
                  </p>
                </div>

                {/* Skin & Hair Care */}
                <div className="veenadoc-article-block">
                  <h2>Advanced Skin & Hair Care Solutions</h2>
                  <p>
                    She is highly recognized for her work in skin and hair care. Many patients search for a homeopathy skin doctor 
                    in Valasaravakkam Chennai or a homeopathy hair fall specialist near Porur, and they find effective solutions 
                    with her. She treats acne, pigmentation, psoriasis, eczema, dermatitis, and vitiligo with individualized 
                    homeopathy plans.
                  </p>
                  <p>
                    For hair-related issues such as dandruff, scalp infections, hair thinning, and chronic hair fall, she offers 
                    targeted therapies that restore scalp health and stimulate natural hair growth. Her training in facial aesthetics 
                    and cosmetology adds further expertise in skin rejuvenation, acne scars, pigmentation removal, and anti-aging treatments.
                  </p>
                </div>

                {/* Facial Aesthetics */}
                <div className="veenadoc-article-block">
                  <h2>Leading Facial Aesthetics & Clinical Cosmetology</h2>
                  <p>
                    Her Fellowship in Facial Aesthetics and Clinical Cosmetology (FFAC) from IICAD Academy makes her one of the 
                    most qualified facial aesthetics doctors in Chennai. Patients looking for the best facial aesthetics doctor 
                    in Valasaravakkam or a cosmetic doctor in Chennai often choose her because of her ability to deliver natural 
                    yet visible results.
                  </p>
                  <p>
                    She provides advanced solutions for skin rejuvenation, acne scars, pigmentation removal, wrinkle reduction, 
                    anti-aging treatments, and cosmetic enhancements, combining safe homeopathic remedies with modern aesthetic 
                    procedures for enhanced results.
                  </p>
                </div>

                {/* Yoga Integration */}
                <div className="veenadoc-article-block">
                  <h2>Yoga Therapy & Holistic Wellness</h2>
                  <p>
                    Her Diploma in Yoga allows her to incorporate therapeutic yoga practices into her treatments. Patients searching 
                    for a yoga and homeopathy doctor in Valasaravakkam benefit from her guidance in lifestyle management, immunity 
                    building, stress relief, and overall wellness.
                  </p>
                  <p>
                    By combining yoga with homeopathy and naturopathy principles, she helps patients make long-term lifestyle changes 
                    that complement their medical treatment, ensuring holistic healing that addresses both body and mind.
                  </p>
                </div>

                {/* Child Psychology */}
                <div className="veenadoc-article-block">
                  <h2>Child Psychology & Pediatric Care</h2>
                  <p>
                    Her child psychology training makes her an excellent choice for families and parents looking for natural and 
                    gentle healthcare solutions for children. As a homeopathy doctor for child health in Valasaravakkam, she 
                    provides holistic support for behavioral concerns, stress, learning challenges, and emotional well-being.
                  </p>
                  <p>
                    Parents searching online for a female homeopathy doctor for children in Chennai or a holistic pediatric doctor 
                    in Valasaravakkam find her consultations reassuring and effective, as she treats common pediatric ailments 
                    safely without harmful side effects.
                  </p>
                </div>

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block">
                  <h2>Philosophy of Holistic Healthcare</h2>
                  <p>
                    Her philosophy reflects a blend of empathy and professionalism. She strongly believes that "The good physician 
                    treats the disease, the great physician treats the patient who has the disease." This patient-first approach 
                    ensures that she not only focuses on curing symptoms but also on building trust, understanding emotions, and 
                    improving quality of life.
                  </p>
                  <p>
                    By combining her skills across multiple specialties, she ensures that patients receive care that is comprehensive 
                    and transformative, addressing not only physical health but also emotional balance, lifestyle wellness, and 
                    cosmetic enhancement.
                  </p>
                </div>

                {/* Patient Experience */}
                <div className="veenadoc-article-block">
                  <h2>Patient Experience & Comprehensive Care</h2>
                  <p>
                    Her patients consistently appreciate her approachable nature, clear communication, and ability to explain medical 
                    conditions in simple terms. Many highlight her dedication to detail, gentle care, and the confidence she instills 
                    during consultations. At H-Cura Valasaravakkam, she has quickly earned a reputation as one of the most trusted 
                    female homeopathy doctors in Chennai.
                  </p>
                  <p>
                    Whether it is a patient searching for a homeopathy doctor for thyroid in Valasaravakkam, a holistic doctor for 
                    arthritis and chronic pain near Porur, a female doctor for PCOS and infertility in Ramapuram, or a cosmetic 
                    doctor in Chennai for anti-aging treatments, she has the expertise and compassion to deliver effective results.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. M. Muthumari for Holistic Healthcare Excellence</h2>
                  <p>
                    By consulting Dr. Muthumari at H-Cura Homeopathy Clinic, Valasaravakkam, Chennai, patients are not only seeking 
                    treatment but also entering a journey of holistic healing. She embodies the modern approach to homeopathy, where 
                    traditional medicine meets advanced aesthetics, lifestyle therapy, and mental wellness support.
                  </p>
                  <p>
                    For anyone looking for a female homeopathy doctor in Valasaravakkam, a holistic doctor in Porur or Alwarthirunagar, 
                    a yoga and naturopathy doctor in Chennai, or the best facial aesthetics specialist near Ramapuram, Dr. M. Muthumari 
                    at H-Cura Valasaravakkam Chennai is the right choice for safe, effective, and compassionate healthcare.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To make healthcare natural, safe, and accessible, focusing on restoring balance 
                    to both body and mind through integrated holistic medicine.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "The good physician treats the disease, the great physician treats the patient who has the disease"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. M. Muthumari's Philosophy of Care</p>
                  </div>
                  <p>
                    She believes that true healing goes beyond temporary relief of symptoms and requires addressing the root 
                    cause of illness. This patient-centric approach has positioned her among the best holistic homeopathy 
                    doctors in Chennai, where she provides customized treatments for individuals of all age groups.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>H-Cura Valasaravakkam, Chennai</h4>
                      <p>Primary practice location</p>
                    </div>
                  </div>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Serving Porur & Alwarthirunagar</h4>
                      <p>Extended care services</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience holistic healthcare with Dr. Muthumari's integrated approach combining homeopathy, aesthetics, yoga, and psychology.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button
                  className="veenadoc-sidebar-btn-secondary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>


       <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default MuthumariDoc
